<template>
    <div :class="`Flag fflag ff-round fflag-${country} ff-md`" />
</template>
<script>
export default {
    props: {
        country: {
            type: String,
            default: () => ('')
        }
    }
}
</script>
<style lang="scss">
.Flag {
     border: 1px solid white;
}
</style>
